const React = require('react');
const T = require('prop-types');
const { connect } = require('react-redux');

const { context } = require('../app-context');
const SimpleDialog = require('components/SimpleDialog');

const actions = context.actions;
const selectors = context.selectors.all;

function AppDialog(props) {

    const {
        appMessage,
        clearAppMessage,
        content,
        messageKey,
        onConfirm,
        onRequestClose,
        title,
        ...rest
    } = props;

    const clearMessage = () => {

        clearAppMessage({
            key: messageKey
        });
    };

    const handleClose = () => {

        clearMessage();
        onRequestClose?.();
    };

    const handleConfirm = () => {

        clearMessage();
        onConfirm?.();
    };

    return <SimpleDialog
        isOpen={!!appMessage}
        onRequestClose={handleClose}
        onConfirm={handleConfirm}
        title={appMessage?.title || title}
        content={appMessage?.message || content}
        {...rest}
    />;
}

AppDialog.propTypes = {
    appMessage: T.shape({
        title: T.string,
        message: T.string,
        createdAt: T.number
    }),
    clearAppMessage: T.func.isRequired,
    content: T.any,
    messageKey: T.string.isRequired,
    onConfirm: T.func,
    onRequestClose: T.func,
    title: T.string
};

module.exports = connect(
    (state, ownProps) => ({
        appMessage: selectors.getAppMessage(state, ownProps.messageKey)
    }),
    {
        clearAppMessage: actions.app.clearAppMessage
    }
)(AppDialog);
